(function (window, document, $) {
'use strict';

var setupTabMenu = function(tabIndex, currentTab, opts) {
  var options = opts || {};
  var $tabSwitcher = $(currentTab);
  var $regions = $tabSwitcher.find('.region');
  var primaryTab = 0;

  if ($regions.length < 2 || 5 < $regions.length) {
    return;
  }

  var dataId = $tabSwitcher.data('id');
  var id = $tabSwitcher.attr('id');
  var overrides = regionSwitcherActiveTabOverrides();

  if (overrides.byId[id]) {
    primaryTab = parseInt(overrides.byId[id], 10);
  } else if (overrides.byDataId[dataId]) {
    primaryTab = parseInt(overrides.byDataId[dataId], 10);
  } else if (overrides.byIndex[tabIndex]) {
    primaryTab = parseInt(overrides.byIndex[tabIndex], 10);
  }

  var tabTitles =  $tabSwitcher.data('tabtitles').split(/\s*,\s*/);

  var $button = $('<button>', {'class': 'tab-btn-trigger'});
  var $buttonTitle = $('<span>', {'class': 'tab-btn-text', text: tabTitles[primaryTab]});
  var $buttonIcon = $('<span>', {'class': 'tab-arrowicon glyph-chevron-down'});
  $button.append($buttonTitle).append($buttonIcon);

  var colorPattern = /primary-grey\d+/;
  var colorMatch = $tabSwitcher.attr('class').match(colorPattern);
  var switcherColor = colorMatch ? colorMatch[0] : 'primary-grey0';

  var $tabList = $('<ul>', {'class': 'tabs'});

  $regions.each(function (i, el) {
    var regionLookup = ['region', tabIndex, '-', i].join('');
    var $region = $(el);
    var regionClass = $region.attr('class');
    var updatedClass = [regionClass.replace(colorPattern, switcherColor), 'r-tab', regionLookup].join(' ');
    $region.attr('class', updatedClass);
    var $tabListItem = $('<li>', {'class': 'tab-title'});
    var $tabListButton = $('<a>', {href: '#', text: tabTitles[i]}).data({region: regionLookup}).toggleClass('active', i === primaryTab);
    $tabListItem.append($tabListButton).appendTo($tabList);
  }).hide().eq(primaryTab).show();

  $tabSwitcher.addClass('tabs-' + $regions.length);

  var $tabListParent = $tabSwitcher.find(options.tabListLocation);
  if ($tabListParent.length) {
    $tabListParent.prepend($tabList);
  } else {
    $tabSwitcher.prepend($tabList);
  }

  if (!options.mobileDropdownMenu) {
    $tabSwitcher.prepend($button);
  }

  $tabList.on('click', 'a', function (e) {
    e.preventDefault();
    var $clickedTab = $(this);
    $tabList.find('a').removeClass('active');
    $clickedTab.addClass('active');
    $regions.hide().filter('.' + $clickedTab.data('region')).show();
    $buttonTitle.text($clickedTab.text());
    $tabList.removeClass('tabs-open');
    $buttonIcon.removeClass('glyph-chevron-up').addClass('glyph-chevron-down');
  });

  $button.on('click', function (e) {
    e.preventDefault();
    $tabList.toggleClass('tabs-open');
    $buttonIcon.toggleClass('glyph-chevron-down glyph-chevron-up');
  });
};

var regionSwitcherActiveTabOverrides = (function () {
  var cache;

  return function () {
    if (cache) { return cache; }

    cache = {
      byIndex: {},
      byId: {},
      byDataId: {}
    };

    // tab indexes in url start at 1, but need to convert to start at zero
    var getIndex = function (value) {
      return parseInt(value, 10) - 1 || 0;
    };

    // look for <div data-rsw-container="12345" data-rsw-tab="2" /> type elements for active tab overrides
    $('div[data-rsw-container]').each(function (i, el) {
      var $el = $(el);
      var container = $el.data('rsw-container');
      var activeTab = getIndex($el.data('rsw-tab'));

      // numeric values are for content class Id's set in the data-id attributes of regions
      // non-numberic values are for id attributes of regions
      if (/^\d+$/.test(container)) {
        cache.byDataId[container] = activeTab;
      } else {
        cache.byId[container] = activeTab;
      }
    });

    /*
      look for tab overrides in query parameters of url

      ?rsw=2
        sets second tab for first region switcher

      ?rsw=pricing:2
        sets second tab for region switcher with id of "pricing"

      ?rsw=2,3
        sets second tab for first region switcher and third tab for second region switcher

      ?rsw=pricing:2,categories:3
        sets second tab for region switcher with id of "pricing" and third tab for region switcher with id of "categories"
    */
    var search = window.location.search.replace(/^\?/, '');
    $.each(search.split('&'), function (index, param) {
        var pair = param.split('=');
    
        if (!/^rsw$/.test(pair[0])) {
          return;
        }

        $.each(pair[1].split(','), function (vIndex, value) {
          var parts = value.split(':');

          if (parts.length === 1) {
            cache.byIndex[vIndex] = getIndex(parts[0]);
          } else {
            cache.byId[parts[0]] = getIndex(parts[1]);
          }
        });
    });

    return cache;
  };
}());

$(document).ready(function() {
  $('div.tsc-tab').each(setupTabMenu);
  $('.grid-tabs-wrapper').each(function (i, el) {
      setupTabMenu(i, el, {
          tabListLocation: '.tablist',
          mobileDropdownMenu: false,
    });
  });
});

}(window, document, jQuery));
